<script>
	import { resetPasswordWithToken } from "../services/api";

	export let token = "";
	export let onGoToLogin = () => {};

	let newPassword = "";
	let confirmPassword = "";
	let showPassword = false;
	let showConfirmPassword = false;

	let isSubmitting = false;
	let errorMessage = "";
	let isSuccess = false;
	let successMessage = "";

	async function handleResetPassword() {
		errorMessage = "";

		if (!token || !token.trim()) {
			errorMessage = "Link de recuperação inválido ou token ausente. Solicite um novo link.";
			return;
		}

		const pwd = newPassword.trim();
		const confirmPwd = confirmPassword.trim();

		if (!pwd) {
			errorMessage = "Informe a nova senha.";
			return;
		}

		if (pwd.length < 4) {
			errorMessage = "A nova senha deve conter no mínimo 4 caracteres.";
			return;
		}

		if (pwd !== confirmPwd) {
			errorMessage = "As senhas informadas não coincidem. Digite novamente.";
			return;
		}

		isSubmitting = true;
		try {
			const res = await resetPasswordWithToken(token.trim(), pwd);
			isSuccess = true;
			successMessage = res.message || "Senha redefinida com sucesso! Você já pode acessar sua conta com a nova senha.";
		} catch (err) {
			errorMessage = err.message || "Não foi possível redefinir a senha. O link pode ter expirado ou já ter sido utilizado.";
		} finally {
			isSubmitting = false;
		}
	}
</script>

<div class="reset-page">
	<div class="reset-card">
		<!-- Logo Oficial -->
		<div class="brand-logo-container">
			<img src="./brand/matafome_logo_hero_dark.png" alt="MataFome" class="brand-logo-img" />
		</div>

		{#if isSuccess}
			<div class="state-container success-state">
				<div class="icon-bubble success-bubble">
					<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
						<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
						<polyline points="22 4 12 14.01 9 11.01"></polyline>
					</svg>
				</div>
				<h2>Senha Atualizada!</h2>
				<p class="state-desc">{successMessage}</p>
				<button type="button" class="btn-primary-action" on:click={onGoToLogin}>
					Ir para o Login
				</button>
			</div>
		{:else}
			<div class="reset-header">
				<h2>Criar Nova Senha</h2>
				<p>Defina sua nova credencial de acesso ao painel do MataFome.</p>
			</div>

			{#if !token}
				<div class="state-container error-state">
					<div class="icon-bubble error-bubble">
						<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#EF4444" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="12" cy="12" r="10"></circle>
							<line x1="12" y1="8" x2="12" y2="12"></line>
							<line x1="12" y1="16" x2="12.01" y2="16"></line>
						</svg>
					</div>
					<p class="state-desc">Nenhum token de recuperação encontrado neste link.</p>
					<button type="button" class="btn-primary-action" on:click={onGoToLogin}>
						Voltar para o Login
					</button>
				</div>
			{:else}
				{#if errorMessage}
					<div class="error-badge">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="12" cy="12" r="10"></circle>
							<line x1="12" y1="8" x2="12" y2="12"></line>
							<line x1="12" y1="16" x2="12.01" y2="16"></line>
						</svg>
						<span>{errorMessage}</span>
					</div>
				{/if}

				<form on:submit|preventDefault={handleResetPassword} class="reset-form">
					<!-- Campo: Nova Senha -->
					<div class="field-group">
						<label for="new-pass-input">Nova Senha (Mínimo 4 caracteres)</label>
						<div class="password-wrapper">
							{#if showPassword}
								<input
									id="new-pass-input"
									type="text"
									placeholder="••••••••"
									bind:value={newPassword}
									disabled={isSubmitting}
									autocomplete="new-password"
									required
								/>
							{:else}
								<input
									id="new-pass-input"
									type="password"
									placeholder="••••••••"
									bind:value={newPassword}
									disabled={isSubmitting}
									autocomplete="new-password"
									required
								/>
							{/if}
							<button
								type="button"
								class="toggle-eye"
								on:click={() => showPassword = !showPassword}
								title="Alternar visibilidade"
								tabindex="-1"
							>
								{#if showPassword}
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
										<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
										<line x1="1" y1="1" x2="23" y2="23"></line>
									</svg>
								{:else}
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
										<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
										<circle cx="12" cy="12" r="3"></circle>
									</svg>
								{/if}
							</button>
						</div>
					</div>

					<!-- Campo: Confirmar Nova Senha -->
					<div class="field-group">
						<label for="confirm-pass-input">Confirmar Nova Senha</label>
						<div class="password-wrapper">
							{#if showConfirmPassword}
								<input
									id="confirm-pass-input"
									type="text"
									placeholder="••••••••"
									bind:value={confirmPassword}
									disabled={isSubmitting}
									autocomplete="new-password"
									required
								/>
							{:else}
								<input
									id="confirm-pass-input"
									type="password"
									placeholder="••••••••"
									bind:value={confirmPassword}
									disabled={isSubmitting}
									autocomplete="new-password"
									required
								/>
							{/if}
							<button
								type="button"
								class="toggle-eye"
								on:click={() => showConfirmPassword = !showConfirmPassword}
								title="Alternar visibilidade"
								tabindex="-1"
							>
								{#if showConfirmPassword}
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
										<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
										<line x1="1" y1="1" x2="23" y2="23"></line>
									</svg>
								{:else}
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
										<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
										<circle cx="12" cy="12" r="3"></circle>
									</svg>
								{/if}
							</button>
						</div>
					</div>

					<button type="submit" class="btn-primary-action" disabled={isSubmitting}>
						{isSubmitting ? "SALVANDO NOVA SENHA..." : "REDEFINIR SENHA"}
					</button>

					<button type="button" class="btn-link-action" on:click={onGoToLogin} disabled={isSubmitting}>
						Cancelar e voltar ao Login
					</button>
				</form>
			{/if}
		{/if}
	</div>
</div>

<style>
	.reset-page {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		min-height: 100%;
		background: radial-gradient(circle at 50% 30%, #1A1F2B 0%, #0A0D14 70%);
		padding: 32px 16px;
		box-sizing: border-box;
		overflow-y: auto;
	}

	.reset-card {
		width: 100%;
		max-width: 420px;
		background: #11141C;
		border: 1px solid rgba(255, 255, 255, 0.08);
		border-radius: 20px;
		padding: 36px 32px 28px 32px;
		box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		gap: 20px;
	}

	.brand-logo-container {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
		max-width: 180px;
	}

	.brand-logo-img {
		width: 100%;
		height: auto;
		display: block;
		object-fit: contain;
	}

	.reset-header {
		text-align: center;
	}

	.reset-header h2 {
		font-size: 20px;
		font-weight: 800;
		color: #FFFFFF;
		margin: 0 0 6px 0;
	}

	.reset-header p {
		font-size: 13px;
		color: #94A3B8;
		margin: 0;
		line-height: 1.4;
	}

	.reset-form {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.field-group {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.field-group label {
		font-size: 11px;
		font-weight: 800;
		color: #CBD5E1;
		text-transform: uppercase;
		letter-spacing: 0.6px;
	}

	.field-group input {
		width: 100%;
		padding: 13px 15px;
		border-radius: 10px;
		border: 1px solid rgba(255, 255, 255, 0.12);
		font-size: 14px;
		font-family: inherit;
		color: #FFFFFF;
		transition: all 0.2s ease;
		background: #171B24;
		box-sizing: border-box;
	}

	.field-group input:focus {
		outline: none;
		border-color: #FF6A00;
		background: #1D222E;
		box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.22);
	}

	.field-group input::placeholder {
		color: #64748B;
	}

	.password-wrapper {
		position: relative;
		display: flex;
		align-items: center;
	}

	.toggle-eye {
		position: absolute;
		right: 12px;
		background: none;
		border: none;
		cursor: pointer;
		color: #64748B;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px;
		transition: color 0.2s;
	}

	.toggle-eye:hover {
		color: #FFFFFF;
	}

	.btn-primary-action {
		background: #FF6A00;
		border: none;
		color: #FFFFFF;
		padding: 14px;
		border-radius: 10px;
		font-size: 14px;
		font-weight: 800;
		letter-spacing: 0.5px;
		cursor: pointer;
		transition: all 0.2s;
		margin-top: 6px;
	}

	.btn-primary-action:hover:not(:disabled) {
		background: #E85A00;
		transform: translateY(-1px);
		box-shadow: 0 6px 20px rgba(255, 106, 0, 0.35);
	}

	.btn-primary-action:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.btn-link-action {
		background: none;
		border: none;
		color: #94A3B8;
		font-size: 13px;
		cursor: pointer;
		padding: 6px;
		text-align: center;
		transition: color 0.2s;
		font-family: inherit;
	}

	.btn-link-action:hover {
		color: #FFFFFF;
	}

	.error-badge {
		background: rgba(239, 68, 68, 0.12);
		border: 1px solid rgba(239, 68, 68, 0.35);
		border-radius: 10px;
		padding: 12px 14px;
		color: #F87171;
		font-size: 13px;
		display: flex;
		align-items: center;
		gap: 10px;
		line-height: 1.4;
	}

	.state-container {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 14px;
		padding: 16px 0;
	}

	.icon-bubble {
		width: 56px;
		height: 56px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.success-bubble {
		background: rgba(16, 185, 129, 0.15);
	}

	.error-bubble {
		background: rgba(239, 68, 68, 0.15);
	}

	.state-container h2 {
		font-size: 20px;
		font-weight: 800;
		color: #FFFFFF;
		margin: 0;
	}

	.state-desc {
		font-size: 14px;
		color: #94A3B8;
		line-height: 1.5;
		margin: 0;
	}
</style>
